import axiosInstance from '../mainService';

const faqService = {
    getFaqs(search, page, limit, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m145_faqs/question/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    totalAllFaqs(search, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m145_faqs/question/${sanitizedSearch}/${company}`);
    },
    addFaq(faq) {
        return axiosInstance.post('/insert-data/m145_faqs', faq);
    },
    deleteFaq(faqId) {
        return axiosInstance.delete(`/delete-data/m145_faqs/${faqId}`);
    },
    updateFaq(faq) {
        return axiosInstance.put(`/update-data/m145_faqs/${faq.id}`, faq);
    }
};

export default faqService;